import type {
  GetHealthRecordsRequest,
  GetHealthRecordsResponse,
  HealthRecord,
} from '@stryd/models';
import {toURLParams} from '@stryd/util-lib/urls/toURLParams';
import type {ClientConfig, HttpClient} from '../../http';

const userPath = '/b/admin/users';

export const setupHealthEndpoints = (client: HttpClient) => {
  return {
    list: (
      userId: string,
      params: GetHealthRecordsRequest,
      config?: ClientConfig
    ) => {
      return client.get<GetHealthRecordsResponse, string>(
        `${userPath}/${userId}/health/records?${toURLParams(params)}`,
        config
      );
    },

    get: (userId: string, id: string, config?: ClientConfig) => {
      return client.get<HealthRecord, string>(
        `${userPath}/${userId}/health/records/${encodeURIComponent(id)}`,
        config
      );
    },
  };
};
